




// helpers.js




const body = document.body;

const breakpoint = {
  xs: 0,
  sm: 426,
  md: 769,
  lg: 1025,
  xl: 1151,
  xxl: 1681,
  current: {
    view: '',
    breakpoint: 0,
  },
};

let isOpen = {
  primaryNav: false,
  filterNav: false,
};









class Component {
  constructor(options, ...vars) {
    this.component = options.component;
    this.callback = options.callback;
    this.vars = vars;

    this.execute();
  }

  execute() {
    if (this.component.length > 0) {
      for (let i = 0; i < this.component.length; i++) {
        const element = this.component[i];
        this.callback(element, this.component, i, this.vars);
      }
    }
  }
}









function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name + "=" + value + expires + ";domain=geckoboard.com;path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}









const currentBreakpoint = ()=>{

  let mql = [];
  const breakpointNames = Object.getOwnPropertyNames(breakpoint);
  breakpointNames.pop();

  const buildMql = ()=>{
    for (let i = 0; i < breakpointNames.length; i++) {
      const brkpt = breakpointNames[i],
        brkptNext = breakpointNames[i + 1];
      
      if (brkptNext) {
        mql.push(window.matchMedia(`(min-width: ${breakpoint[brkpt]}px) and (max-width: ${breakpoint[brkptNext]}px)`));
      } else {
        mql.push(window.matchMedia(`(min-width: ${breakpoint[brkpt]}px)`));
      }
    }
  };

  const updateCurrentBreakpoint = ()=>{
    for (let i = 0; i < mql.length; i++) {
      const brkpt = mql[i];
      let updatedView = null;

      const update = ()=>{
        if (brkpt.matches) {
          if (updatedView != breakpoint.current.view) {
            breakpoint.current.view = breakpointNames[i];
            breakpoint.current.breakpoint = breakpoint[breakpointNames[i]];
            updatedView = breakpointNames[i];
          }
        }
      };

      window.addEventListener(`resize`, update);
      update();
    }
  };

  buildMql();
  updateCurrentBreakpoint();
}
currentBreakpoint();









const exists = (el)=>{
  return document.querySelectorAll(el).length > 0;
}









class Element {
  constructor(options) {
    this.alt = options.alt;
    this.append = {
      before: options.append.before,
      parent: options.append.parent,
    }
    this.attributes = options.attributes;
    this.classes = options.classes;
    this.content = options.content;
    this.el;
    this.href = options.href;
    this.id = options.id;
    this.src = options.src;
    this.type = options.type;

    this.render();
    return this.el;
  }

  appendToElement() {
    if (this.append.before) {
      this.append.parent.insertBefore(this.el, this.append.before);
    } else {
      this.append.parent.appendChild(this.el)
    }
  }

  setAlt() {
    if (this.alt) {
      this.el.alt = this.alt
    }
  }

  setAttributes() {
    if (this.attributes) {
      for (let i = 0; i < this.attributes.length; i++) {
        const attr = this.attributes[i];
        this.el.setAttribute(attr[0], attr[1]);
      }
    }
  }

  setClasses() {
    if (this.classes) {
      if (Array.isArray(this.classes)) {
        for (let i = 0; i < this.classes.length; i++) {
          const cls = this.classes[i];
          this.el.classList.add(cls);
        }
      } else {
        this.el.classList.add(this.classes);
      }
    }
  }

  setContent() {
    if (this.content) {
      this.el.innerHTML = this.content;
    }
  }

  setHref() {
    if (this.href) {
      this.el.href = this.href;
    }
  }

  setId() {
    if (this.id) {
      this.el.id = this.id;
    }
  }

  setSrc() {
    if (this.src) {
      this.el.src = this.src
    }
  }

  render() {
    if (this.type) {
      this.el = document.createElement(this.type);
    } else {
      this.el = document.createElement('p');
    }

    this.setAlt();
    this.setAttributes();
    this.setClasses();
    this.setContent();
    this.setHref();
    this.setId();
    this.setSrc();

    this.appendToElement();
  }
}








const toggleBodyScroll = () => {
  const activeClass = `nav_is_open`;
  let values = [];

  for (let prop in isOpen) {
    values.push(isOpen[prop]);
  }
  
  if (!values.includes(true)) {
    if (body.classList.contains(activeClass)) {
      body.classList.remove(activeClass);
    }
  } else {
    body.classList.add(activeClass);
  }
};









class Responsive {
  constructor(options) {
    this.breakpoint = options.breakpoint;
    this.direction = options.direction;
    this.callback = options.callback;
    this.hasExecuted = false;
    this.executeCallback();
  }

  executeCallback() {
    
    const scripts = (onload) => {
      if (this.callback) {
        let param1, param2;
    
        if (this.direction == 'max' || this.direction == 'down') {
          param1 = breakpoint.current.breakpoint < this.breakpoint;
          param2 = breakpoint.current.breakpoint >= this.breakpoint;
        }
        else {
          param1 = breakpoint.current.breakpoint >= this.breakpoint;
          param2 = breakpoint.current.breakpoint < this.breakpoint;
        }

        if (param1 && !this.hasExecuted) {
          this.hasExecuted = true;
          this.callback(onload, this.direction);
        }
        else if (param2 && this.hasExecuted) {
          this.hasExecuted = false;
        }
      }
    };

    window.addEventListener(`resize`, function() {
      scripts(false);
    });

    scripts(true);
  };
}









const randomNumber = (min, max)=>{
  const random = Math.random() * ((max - min) + 1) + min;
  return Math.ceil(random);
}









const wrapParagraph = (el) => {
  const element = document.querySelectorAll(el);
  for (let i = 0; i < element.length; i++) {
    const el = element[i];
    const nodes = el.childNodes;
    let elements = [];

    const splitLines = (node) => {
      const allLines = node.data.split('\n');
      let contentOnly = [];

      allLines.map((line) => {
        if (line.trim() != "") {
          contentOnly.push(line.trim());
        }
      })

      contentOnly.map((paragraphText) => {
        const p = document.createElement('p');
        p.innerHTML = paragraphText;
        elements.push(p);
        node.data = null;
      })
    }
    
    for (let i = 0; i < nodes.length; i++) {
      let node = nodes[i]

      if (node.nodeType === 3) {
        splitLines(node);
      } else {
        elements.push(node);
      }
    }

    elements.map(node => {
      el.appendChild(node);
    })
  }
}









function slugify(text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}